import styles from "./Dimensions.module.scss";

type Props = {
  productType: string;
  dimensions: string | undefined;
  aperture: string | undefined;
};

export const DimensionsUI = ({ productType, dimensions, aperture }: Props) => {
  const title = aperture
    ? `The size of the space needed for the ${productType} to fit`
    : "Dimensions";
  const displayedDimensions = aperture ?? dimensions;

  if (!displayedDimensions) return null;
  return (
    <section className={styles.dimensions} data-component="Dimensions">
      <h2 className={styles.dimensions__title}>{title}</h2>
      {displayedDimensions}
    </section>
  );
};
